import styled from 'styled-components';

interface ICommentsContainer {
  isMissingAnswer: boolean;
}

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 12px;
  overflow-x: hidden;
  overflow-y: visible;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 8px;
  border-bottom: 2px solid ${({ theme }) => theme.colors.primary.main};
  margin-bottom: 4px;

  .section-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.gray[900]};

    svg {
      width: 18px;
      height: 18px;
      color: ${({ theme }) => theme.colors.primary.main};
    }
  }
`;

export const Section = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.gray[75]};
  border-radius: 12px;
  padding: 14px;
  overflow: visible;
`;

export const CommentsContainer = styled.div<ICommentsContainer>`
  max-height: ${({ isMissingAnswer }) => isMissingAnswer ? '180px' : '280px'};
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: 8px 12px 8px 0;
`;

export const AddCommentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
  overflow: visible;

  > div {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
`;

export const SelectsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  gap: 12px;
  margin-bottom: 8px;

  > div {
    flex: 1;
  }

  .react-select-container {
    .react-select__menu {
      z-index: 9999;
    }
  }
`;

export const AiHistoryButtonWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const AiHistoryButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: ${({ theme }) => theme.colors.primary.main};
  color: #fff;
  border: none;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.primary.dark};
    transform: scale(1.02);
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const AiHistoryPopover = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 1000;
  width: 340px;
  max-height: 320px;
  background: ${({ theme }) => theme.colors.lighterBackground};
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  opacity: ${({ isOpen }) => isOpen ? 1 : 0};
  visibility: ${({ isOpen }) => isOpen ? 'visible' : 'hidden'};
  transform: ${({ isOpen }) => isOpen ? 'translateY(0)' : 'translateY(-8px)'};
  transition: all 0.2s ease;
  overflow: hidden;

  .popover-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: ${({ theme }) => theme.colors.primary.main};
    color: #fff;

    span {
      font-size: 13px;
      font-weight: 600;
    }

    button {
      background: transparent;
      border: none;
      color: #fff;
      cursor: pointer;
      padding: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      transition: background 0.2s;

      &:hover {
        background: rgba(255, 255, 255, 0.2);
      }
    }
  }

  .popover-content {
    padding: 12px;
    max-height: 260px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`;

export const AiMessageBubble = styled.div<{ isUser: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ isUser }) => isUser ? 'flex-end' : 'flex-start'};
  width: 100%;

  .message-label {
    font-size: 10px;
    font-weight: 600;
    color: ${({ theme, isUser }) => isUser ? theme.colors.gray[200] : theme.colors.primary.main};
    margin-bottom: 3px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .message-content {
    background: ${({ theme, isUser }) => isUser ? theme.colors.gray[100] : theme.colors.primary.lighter};
    color: ${({ theme }) => theme.colors.gray[900]};
    padding: 8px 12px;
    border-radius: ${({ isUser }) => isUser ? '10px 10px 2px 10px' : '10px 10px 10px 2px'};
    max-width: 90%;
    font-size: 12px;
    line-height: 1.4;
    white-space: pre-wrap;
    word-break: break-word;
  }
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin: 4px 0px;
  margin-right: 16px;

  div.title {
    margin: 4px 0px;
    font-size: 16px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    div {
      font-size: 16px;
    }
    img {
      &:hover {
        opacity: 0.6
      }
      cursor: pointer;
      filter: ${({ theme }) => theme.filters.primary};
      width: 21px;
      transition: all 0.2s ease-in-out;
    }
  }

  span {
    max-height: 66px;
    overflow: auto;
    margin-bottom: 2px;
  }
`;
